import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import getAvailableFlagsButtons from '../../../../../../helpers/getAvailableFlagsButtons';
import swal from 'sweetalert2';
import {fetchStatsPlayersNumberInTeam} from '../../../../../../actions/entities/statistics/players';
import Filters from '../../../../../../components/Filters';
import FilterLeague from '../../../../../../components/Filters/League';
import FilterLocation from '../../../../../../components/Filters/Location';
import FilterPeriod from '../../../../../../components/Filters/Period';
import Loader from '../../../../../../components/Loader';
import {getChampionshipId} from '../../../../../../helpers/championship';
import './index.css';

class StatsPlayersNumberInTeamWidget extends React.Component {
  constructor(props) {
    super(props);

    // We set the date to yesterday and we subtract 30 days
    const today = new Date();
    const end = moment(today.setDate(today.getDate())).format('YYYY-MM-DD');
    const start = moment(today.setDate(today.getDate() - 30)).format(
      'YYYY-MM-DD',
    );

    this.state = {
      filters: {
        championship: 'ALL',
        period: {end, start},
        league: {nbPlayers: [], mode: []},
      },
      order: {key: 'teamSize', value: 'asc'},
      isFetching: false,
      highlightRefreshBtn: true,
    };
  }

  updateFilters(filter) {
    this.setState({filters: {...this.state.filters, ...filter}});
  }

  notifyRefresh(value) {
    const {highlightRefreshBtn} = this.state;
    this.setState({
      highlightRefreshBtn: value !== undefined ? value : !highlightRefreshBtn,
    });
  }

  selectOrChangeOrder(key) {
    if (key === this.state.order.key)
      this.setState({
        order: {key, value: this.state.order.value === 'asc' ? 'desc' : 'asc'},
      });
    else {
      const newOrder = {key};
      // The switch is necessary for the default sortOrder each orderType
      switch (key) {
        case 'teamSize':
          newOrder.value = 'asc';
          break;
        case 'percentTeamWithThisNbOfPlayers':
          newOrder.value = 'desc';
          break;
        default:
          newOrder.value = 'desc';
      }
      this.setState({order: newOrder});
    }
  }

  fetchStats() {
    const callBacks = {
      onError: error => {
        this.setState({isFetching: false});
        swal({
          title: `Oops...`,
          type: 'error',
          html:
            `Something went wrong !<br/>${error}<br/>` +
            `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
        });
      },
      onRequest: () => this.setState({isFetching: true}),
      onSuccess: () => {
        this.setState({isFetching: false});
        this.notifyRefresh(false);
      },
    };

    if (!this.state.isFetching) {
      const {period, league} = this.state.filters;
      const payload = {
        endDate: moment(period.end).format('YYYY-MM-DD'),
        startDate: moment(period.start).format('YYYY-MM-DD'),
        divisionSizes: league.nbPlayers,
        modes: league.mode,
      };
      this.props.dispatch(fetchStatsPlayersNumberInTeam(payload, callBacks));
    }
  }

  componentDidMount() {
    this.fetchStats();
  }

  renderTable() {
    const cols = {
      teamSize: 'Number of players',
      percentTeamWithThisNbOfPlayers: '% Teams',
    };

    const {order, filters} = this.state;
    const {championship} = filters;
    const {data} = this.props;

    const formatData = oldData => {
      let newData = [];
      let total = 0;

      if (!oldData) return [];

      oldData.forEach(
        ({totalTeamsWithThisSize}) => (total += totalTeamsWithThisSize),
      );
      oldData.forEach(({teamSize, totalTeamsWithThisSize}) => {
        const percent = (parseInt(totalTeamsWithThisSize, 10) / total) * 100;
        newData.push({
          teamSize,
          percentTeamWithThisNbOfPlayers: parseInt(
            numeral(percent).format('0,0'),
            10,
          ),
        });
      });
      return newData;
    };

    let playersNumbers = {};
    if (championship === 'ALL') {
      const mergedData = {};
      Object.values(data).forEach(c =>
        c.forEach(({teamSize, totalTeamsWithThisSize}) => {
          const currentTotal =
            mergedData[teamSize] && mergedData[teamSize].totalTeamsWithThisSize;
          mergedData[teamSize] = {
            teamSize,
            totalTeamsWithThisSize: currentTotal
              ? currentTotal + totalTeamsWithThisSize
              : totalTeamsWithThisSize,
          };
        }),
      );
      playersNumbers = formatData(Object.values(mergedData));
    } else {
      const dataByChampionship = data[getChampionshipId(championship)];
      playersNumbers = formatData(dataByChampionship);
    }

    return isEmpty(playersNumbers) ? (
      <p className="text-center px-3 pb-3">No data to show</p>
    ) : (
      <div className="table-responsive table-fixed-height">
        <table className="table table-striped">
          <thead>
            <tr>
              {map(cols, (value, key) => (
                <th key={key}>
                  <span
                    onClick={() => this.selectOrChangeOrder(key)}
                    className={classNames('orderBtn', {
                      'text-primary': order.key === key,
                    })}>
                    {value}&nbsp;
                    <i
                      className={classNames('fa', {
                        'fa-sort': order.key !== key,
                        [`fa-sort-${order.value}`]: order.key === key,
                      })}
                    />
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {orderBy(playersNumbers, [order.key], [order.value]).map(nb => (
              <tr key={nb.teamSize}>
                {map(cols, (value, key) => (
                  <td key={`nb-${nb.teamSize}-${key}`}>
                    {isNumber(nb[key])
                      ? numeral(nb[key]).format('0,0')
                      : nb[key]}
                    {key.indexOf('percent') > -1 && ' %'}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const {isFetching, highlightRefreshBtn} = this.state;
    const {championships} = this.props;
    if (isEmpty(championships)) {
      return <></>;
    }

    return (
      <div id="stats-players-numberInTeam-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-sort-numeric-asc" />
              {` Number of players in team`}
            </h3>
          </div>
          <div className="box-body">
            <div className="margin-bottom">
              <Filters>
                <FilterLocation
                  label="Championship:"
                  availableButtons={getAvailableFlagsButtons(
                    this.props.championships,
                  )}
                  onChange={championship => this.updateFilters({championship})}
                  initialValue={this.state.filters.championship}
                />
                <FilterLeague
                  label="Leagues:"
                  onChange={league => {
                    this.updateFilters({league});
                    this.notifyRefresh(true);
                  }}
                  initialValues={this.state.filters.league}
                />
                <FilterPeriod
                  label="Date range:"
                  onChange={period => {
                    this.updateFilters({period});
                    this.notifyRefresh(true);
                  }}
                  buttonGroup={{
                    icon: 'fa fa-refresh',
                    type: highlightRefreshBtn ? 'success' : 'default',
                    onClick: this.fetchStats.bind(this),
                  }}
                  initialValues={this.state.filters.period}
                />
              </Filters>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTable()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => {
    const {statistics, championships} = state.app;
    return {
      data: statistics.players.numberInTeam,
      championships: championships.list.data,
    };
  },
  dispatch => ({dispatch}),
)(StatsPlayersNumberInTeamWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Players/NumberInTeam/index.js